module.exports = __webpack_public_path__ + "media/images/appstore_image-af8fe740.png";